// src/lib/axios.js
import axios from 'axios'
const baseURL = process.env.VUE_APP_API_BASE_URL
const instance = axios.create({
  baseURL
})
instance.interceptors.request.use((config) => {
	return config
}, (error) => {
	return Promise.reject(error)
})
// 响应拦截器
instance.interceptors.response.use(async (response) => {
	const {code, data} = response.data
	if (code === 0 || code === 'success') {
		return data
	}
	return Promise.reject(response.data)
}, (err) => {
	return Promise.reject(err)
});

export function $get(url, params, config) {
  return instance.get(url, { params, ...config })
}

export function $post(url, data, config) {
  return instance.post(url, data, config)
}

export function $put(url, data, config) {
  return instance.put(url, data, config)
}

export function $del(url, config) {
  return instance.delete(url, config)
}


